<svg-icon
  class="field-description-icon"
  [key]="readonly ? 'qmarkBlack' : 'qmarkGrey'"
  fontSize="14px"
  ngxTippy
  tippyClassName="tippy-white"
  [tippyProps]="{
    allowHTML: true,
    interactive: interactive,
    appendTo: interactive ? documentBody : undefined,
    zIndex: interactive ? 10000006 : undefined,
    placement: position,
    content: description | translate,
    maxWidth: 500
  }"
>
</svg-icon>
<!-- <popper-content #descriptionContent>
  <div
    class="description-content"
    [innerHTML]="description"
  ></div>
</popper-content> -->
